export function downloadWeddingICS(lang = "tr") {
  const title = lang === "tr" ? "Büşra & Furkan Düğünü" : "Büşra & Furkan Wedding";
  const loc =
    "Başak Düğün Salonu, Başak Mah. 5. Etap Vadi Center, Ali Soylu Cd., Başakşehir / İstanbul / Türkiye";
  const desc =
    lang === "tr"
      ? "Aşkın yolculuğu başlıyor. Sizi bekliyoruz! ♥ Uçuş BF1607 · IST → SAL"
      : "The journey of love begins. We can't wait to see you! ♥ Flight BF1607 · IST → SAL";
  // 13:00 (+03:00) = 10:00 UTC, ends 17:00 (+03:00) = 14:00 UTC
  const dtStart = "20261115T100000Z";
  const dtEnd = "20261115T140000Z";
  const uid = `busra-furkan-${Date.now()}@wedding-passport`;
  const stamp = new Date().toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";

  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//WeddingPassport//TR",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${stamp}`,
    `DTSTART:${dtStart}`,
    `DTEND:${dtEnd}`,
    `SUMMARY:${title}`,
    `DESCRIPTION:${desc}`,
    `LOCATION:${loc}`,
    "BEGIN:VALARM",
    "TRIGGER:-P1D",
    "ACTION:DISPLAY",
    `DESCRIPTION:${title}`,
    "END:VALARM",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");

  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "busra-furkan-dugun.ics";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}
